import React from 'react';
import CloudHero from './components/CloudHero';
import CloudServices from './components/CloudServices';
import CloudProcess from './components/CloudProcess';
import CloudTechStack from './components/CloudTechStack';
import WhyChooseUs from '../SoftwareDevelopment/components/WhyChooseUs';
import ContactFormWidget from '../../../components/ContactFormWidget';
import Footer from '../../../components/Footer';

const CloudSolutions = () => {
  return (
    <div className="cloud-solutions-page">
      <CloudHero />
      <CloudServices />
      <CloudProcess />
      <CloudTechStack />
      <WhyChooseUs />
      <ContactFormWidget />
      <Footer />
    </div>
  );
};

export default CloudSolutions; 